/* Store 01 — Cart Toast
   Implements <cart-notification> so Dawn's product-form.js does an AJAX add and
   calls renderContents() here (instead of redirecting to /cart). */
if (!customElements.get('cart-notification')) {
  customElements.define(
    'cart-notification',
    class CartNotification extends HTMLElement {
      constructor() {
        super();
        this.card = this.querySelector('.s01-toast__card');
        this.img = this.querySelector('[data-toast-img]');
        this.thumb = this.querySelector('.s01-toast__thumb');
        this.nameEl = this.querySelector('[data-toast-name]');
        this.subEl = this.querySelector('[data-toast-sub]');
        this.countLabel = this.querySelector('[data-toast-count-label]');
        this.totalEl = this.querySelector('[data-toast-total]');
        this.progress = this.querySelector('.s01-toast__progress');
        this.currency = this.dataset.currency || 'USD';
        this.locale = this.dataset.locale || navigator.language || 'en';
        this.activeElement = null;

        this.querySelector('[data-toast-close]')?.addEventListener('click', () => this.hide());
        this.addEventListener('mouseenter', () => this.classList.add('is-paused'));
        this.addEventListener('mouseleave', () => this.classList.remove('is-paused'));
        this.progress?.addEventListener('animationend', () => this.hide());
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.classList.contains('is-open')) this.hide();
        });
      }

      // Called by product-form.js — we don't need Shopify section rendering.
      getSectionsToRender() {
        return [];
      }

      setActiveElement(element) {
        this.activeElement = element;
      }

      renderContents(parsed) {
        const it = parsed && parsed.items && parsed.items.length ? parsed.items[0] : parsed;
        if (!it) return;

        const imgUrl = (it.featured_image && it.featured_image.url) || it.image;
        if (imgUrl && this.img) {
          this.img.src = imgUrl.replace(/(\.(?:png|jpe?g|webp|gif|avif))(\?|$)/i, '_120x$1$2');
          this.img.alt = it.product_title || it.title || '';
          if (this.thumb) this.thumb.hidden = false;
        } else if (this.thumb) {
          this.thumb.hidden = true;
        }

        if (this.nameEl) this.nameEl.textContent = it.product_title || it.title || 'Item';

        const parts = [];
        if (it.variant_title && it.variant_title !== 'Default Title') parts.push(it.variant_title);
        parts.push('Qty ' + (it.quantity || 1));
        if (this.subEl) this.subEl.textContent = parts.join('  ·  ');

        this.show();
        this.syncAndRefresh();
      }

      // Reconcile the free gift(s) (if enabled) BEFORE updating totals, so the
      // popup reflects the true cart — including any gift line(s) — in one paint.
      // The celebration itself (which gift, animation) is owned entirely by the
      // <s01-gift-modal> in assets/s01-free-gift.js — this toast never repeats it.
      syncAndRefresh() {
        const fg = window.S01FreeGift;
        const pending =
          fg && fg.promos && typeof fg.ensure === 'function' ? fg.ensure() : Promise.resolve(null);
        pending.then((cart) => this.refreshCart(cart)).catch(() => this.refreshCart());
      }

      refreshCart(cart) {
        if (cart) {
          this.applyCart(cart);
          return;
        }
        const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((c) => this.applyCart(c))
          .catch(() => {});
      }

      applyCart(cart) {
        if (!cart) return;
        const count = cart.item_count;
        if (this.countLabel) {
          this.countLabel.textContent = count + (count === 1 ? ' item in your cart' : ' items in your cart');
        }
        if (this.totalEl) this.totalEl.textContent = this.money(cart.items_subtotal_price);
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = count;
          el.classList.toggle('hidden', count === 0);
          el.classList.remove('s01-bump');
          void el.offsetWidth;
          el.classList.add('s01-bump');
        });
      }

      money(cents) {
        try {
          return new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.currency }).format(
            (cents || 0) / 100
          );
        } catch (e) {
          return '$' + ((cents || 0) / 100).toFixed(2);
        }
      }

      show() {
        this.classList.add('is-open');
        this.classList.remove('is-paused');
        // Restart the auto-dismiss progress animation
        if (this.progress) {
          this.progress.style.animation = 'none';
          void this.progress.offsetWidth;
          this.progress.style.animation = '';
        }
        // Restart the checkmark draw
        if (this.card) {
          this.card.classList.remove('s01-animate');
          void this.card.offsetWidth;
          this.card.classList.add('s01-animate');
        }
      }

      hide() {
        this.classList.remove('is-open');
      }
    }
  );
}
